// imported from https://github.com/component/has-cors
var value = false;

try {
  value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {// if XMLHttp support is disabled in IE then it will throw
  // when trying to create
}

export var hasCORS = value;